import React, {useState, useEffect} from "react"
import Row from "@amzn/meridian/row"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Table, {TableRow, TableCell} from "@amzn/meridian/table";
import Column from "@amzn/meridian/column";
import {getDriverShipmentListDetails} from "../../driverReconciliation/network/driverShipmentDetailsAPI";
import Currency from "../../common/currency";
import Button from "@amzn/meridian/button";
import {
    downloadDriverShipmentListDetailsExcel
} from "./driverShipmentDetailExcelDownload";
import Select, {SelectOption} from "@amzn/meridian/select";
import Tag from "@amzn/meridian/tag";



const OverviewSection = ({values}) => {
    console.log({values});

    return (<Box>
        <Column space="small">
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Driver Name</Text>
                {values.driverInfo.name}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Employee Id</Text>
                {values.compEmployeeId}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">DSP Name</Text>
                {values.providerInfo.name}
            </Row>

        </Column>
    </Box>);
}

const PayMethodSelectionSection = ({values}) => {

    const [payMethods] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const payMethodsSet = new Set()

    values.shipmentSettlementDetailList && values.shipmentSettlementDetailList.forEach(function (shipmentSettlementDetail, index) {
        const {paymentMethod} = shipmentSettlementDetail;
        if (paymentMethod) {
            payMethodsSet.add(paymentMethod)
        }
    })

    useEffect(() => {
        if(selectOptions.length === 0)
            setFilteredData([...(values.shipmentSettlementDetailList || [])])
        else if (values.shipmentSettlementDetailList)
            setFilteredData( values.shipmentSettlementDetailList.filter(resp => selectOptions.includes(resp.paymentMethod)))
    }, [selectOptions, values.shipmentSettlementDetailList])

    const onValueChange = values => {
        setSelectOptions(values)
    }

    return (
        <React.Fragment>
            <Column>
                <Select width={"30%"} placeholder={"Select the payment method"}
                    value={selectOptions}
                    onChange={onValueChange}
                    popoverPosition="adjacent"
                >
                    {Array.from(payMethodsSet).map(option => (
                        <SelectOption label={option} value={option} key={option} />
                    ))}
                </Select>
                <Row>
                    {payMethods.map(value => {
                        const option = payMethods.find(option => option.value === value)
                        return (
                            <Tag
                                key={option.value}
                                type="neutral"
                            >
                                {option.label}
                            </Tag>
                        )
                    })}
                </Row>
            </Column>

            <DriverShipmentListDetailsSection values={filteredData} />

        </React.Fragment>
    )

}

const DriverShipmentListDetailsSection = ({values}) => {
    return (
        <Table headerRows={1}>
            <TableRow>
                <TableCell>Tracking Id</TableCell>
                <TableCell>Shipment Type</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Update Status Date</TableCell>
                <TableCell>Payment Method</TableCell>
                <TableCell>Receivable Amount</TableCell>
                <TableCell>Received Amount</TableCell>
            </TableRow>

            {values && values.map(function (shipmentSettlementDetail, index) {
                const {barcode, shipmentType, shipmentStatus, updateDate, paymentMethod, receivableAmount, receivedAmount} = shipmentSettlementDetail;

                return <TableRow key={index}>
                    <TableCell>{barcode || "NA"}</TableCell>
                    <TableCell>{shipmentType || "NA"}</TableCell>
                    <TableCell>{shipmentStatus || "NA"}</TableCell>
                    <TableCell>{updateDate || "NA"}</TableCell>
                    <TableCell>{paymentMethod || "NA"}</TableCell>
                    <TableCell>{receivableAmount?<Currency amount={receivableAmount} isVariance={true}/> : "NA"}</TableCell>
                    <TableCell>{receivedAmount?<Currency amount={receivedAmount} isVariance={true}/> : "NA"}</TableCell>

                </TableRow>
            })}

        </Table>
    );
}

const ErrorMessageSection = ({values}) => {
    console.log("errorMessage: " + values);
    if (values.length) {
        return (
            <Box spacingInset="small none">
                <Row>
                    <Text color="secondary" >{values}</Text>
                </Row>
            </Box>

        );
    }
    else return null;
}

const DriverShipmentListDetailsDownloadExcelSection = ({values}) => {
    console.log(values)
    return (
        <div>
            <div>
                <Button size="small" onClick={() => downloadDriverShipmentListDetailsExcel(values)}
                        disabled={!values.shipmentSettlementDetailList
                        || (values.shipmentSettlementDetailList && values.shipmentSettlementDetailList.length === 0)}>
                    Download
                </Button>
            </div>
        </div>
    );
}

const DriverShipmentListDetailsModal = (props) => {
    const { onClose, driverShipmentListDetailsModalData, value } = props;
    const [driverShipmentListDetailsAPIResponse, setDriverShipmentListDetailsAPIResponse] = useState({});
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        if (Object.keys(driverShipmentListDetailsModalData).length && value) {
            setDriverShipmentListDetailsAPIResponse([])
            setErrorMessage({})
            getDriverShipmentListDetails(driverShipmentListDetailsModalData)
                .then(result => {
                    if (result.hasError) {
                        setErrorMessage(result.errorMessage)
                    }
                    else {
                        setDriverShipmentListDetailsAPIResponse(result)
                        console.log("driverShipmentListDetailsAPIResponse: " + driverShipmentListDetailsAPIResponse);
                    }
                })

        }
    },[driverShipmentListDetailsModalData]);

    return (
        <React.Fragment>
            <ModalExample title="Driver Shipment Details" open={props.value} scrollContainer="viewport"
                          closeLabel="Close" onClose={onClose}>
                {
                    <OverviewSection values={driverShipmentListDetailsModalData}/>
                }

                <br/>
                <br/>

                {
                    <PayMethodSelectionSection values={driverShipmentListDetailsAPIResponse} />
                }

                <br/>
                <br/>
                <br/>

                {
                    <ErrorMessageSection values={errorMessage} />
                }

                <br/>

                {
                    <DriverShipmentListDetailsDownloadExcelSection values={driverShipmentListDetailsAPIResponse} />
                }

            </ModalExample>

        </React.Fragment>
    )
}

export default DriverShipmentListDetailsModal;


// WEBPACK FOOTER //
// ./src/component/modal/driverReconciliation/driverShipmentListDetailsModal.js